export const SET_COUNT = 'wishlist-count/SET_COUNT'
export const INCREMENT_COUNT = 'wishlist-count/INCREMENT_COUNT'
export const DECREMENT_COUNT = 'wishlist-count/DECREMENT_COUNT'
export const INIT_GUEST_FAVORITES = 'wishlist/INIT_GUEST_FAVORITES'
export const ADD_GUEST_FAVORITE = 'wishlist/ADD_GUEST_FAVORITE'
export const REMOVE_GUEST_FAVORITE = 'wishlist/REMOVE_GUEST_FAVORITE'
